(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.documentElement.classList.add('u-ready');

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('in');
        io.unobserve(en.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: .08 });
  document.querySelectorAll('.u-rv').forEach(function (el) { io.observe(el); });

  /* wavy / diagram svg draw-in */
  document.querySelectorAll('.u-wavy-svg, .u-diagram').forEach(function (el) {
    new IntersectionObserver(function (e, o) {
      if (e[0].isIntersecting) { el.classList.add('in'); o.disconnect(); }
    }, { threshold: .3 }).observe(el);
  });

  /* ---------- count up (chiffres clés) ---------- */
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      cio.unobserve(en.target);
      var el = en.target, target = parseFloat(el.dataset.count), dur = reduce ? 0 : 1400, st = null;
      if (!dur || isNaN(target)) { el.textContent = (target || 0).toLocaleString('fr-FR'); return; }
      function step(ts) {
        if (!st) st = ts;
        var k = Math.min(1, (ts - st) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(target * e).toLocaleString('fr-FR');
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: .5 });
  document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

  /* ---------- comparateur avant / après ---------- */
  document.querySelectorAll('.u-compare').forEach(function (cmp) {
    var after = cmp.querySelector('.u-after'), pos = 50, dragging = false;
    function setPos(v) {
      pos = Math.max(0, Math.min(100, v));
      cmp.style.setProperty('--u-pos', pos + '%');
      if (after) after.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      cmp.setAttribute('aria-valuenow', Math.round(pos));
    }
    function fromEvent(e) {
      var r = cmp.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setPos(x / r.width * 100);
    }
    cmp.addEventListener('pointerdown', function (e) { dragging = true; cmp.setPointerCapture(e.pointerId); fromEvent(e); });
    cmp.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    cmp.addEventListener('pointerup', function () { dragging = false; });
    cmp.addEventListener('pointercancel', function () { dragging = false; });
    cmp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { setPos(pos - 4); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPos(pos + 4); e.preventDefault(); }
    });
    setPos(50);
    if (!reduce) {
      new IntersectionObserver(function (en, o) {
        if (!en[0].isIntersecting) return;
        o.disconnect();
        var s = null;
        function anim(ts) {
          if (!s) s = ts;
          var k = Math.min(1, (ts - s) / 1600);
          var e2 = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
          setPos(50 + Math.sin(e2 * Math.PI) * 26);
          if (k < 1) requestAnimationFrame(anim);
        }
        requestAnimationFrame(anim);
      }, { threshold: .5 }).observe(cmp);
    }
  });

  /* ---------- FAQ accordéon ---------- */
  document.querySelectorAll('.u-acc').forEach(function (acc) {
    acc.querySelectorAll('.u-acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.u-acc-item'),
          panel = document.getElementById(btn.getAttribute('aria-controls')),
          open = item.classList.contains('u-open');

        acc.querySelectorAll('.u-acc-item.u-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('u-open');
          other.querySelector('.u-acc-btn').setAttribute('aria-expanded', 'false');
          other.querySelector('.u-acc-panel').style.height = '0px';
        });

        if (open) {
          item.classList.remove('u-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.style.height = '0px';
        } else {
          item.classList.add('u-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        }
      });
    });
  });

  /* ---------- vidéo hero : pause hors écran ---------- */
  document.querySelectorAll('.u-hero video').forEach(function (hv) {
    hv.play().catch(function () {});
    new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { hv.play().catch(function () {}); } else { hv.pause(); }
    }, { threshold: .05 }).observe(hv);
  });

  /* ---------- ancres douces ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---------- barre CTA sticky bas de page ---------- */
  var bar = document.querySelector('.u-stickybar');
  if (bar) {
    var closed = false;
    var closeBtn = bar.querySelector('.u-stickybar-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closed = true;
        bar.classList.remove('u-show');
      });
    }
    var onScroll = function () {
      if (closed) return;
      bar.classList.toggle('u-show', window.scrollY > window.innerHeight * .6);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- effets au défilement ---------- */
  (function () {
    var de = document.documentElement;
    if (reduce) return;

    /* apparitions en cascade : chaque élément d'une même rangée arrive avec un léger décalage */
    var rvs = [].slice.call(document.querySelectorAll('.u-rv'));
    rvs.forEach(function (el) {
      var p = el.parentElement;
      if (!p || /u-rv-d\d/.test(el.className)) return;
      var sib = [].filter.call(p.children, function (c) { return c.classList && c.classList.contains('u-rv'); });
      el.style.setProperty('--u-i', String(Math.min(sib.indexOf(el), 5)));
    });
    /* une fois apparu, on retire le décalage pour que les survols restent instantanés */
    var clr = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        clr.unobserve(e.target);
        setTimeout(function () { e.target.style.setProperty('--u-i', '0'); }, 2400);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .08 });
    rvs.forEach(function (el) { clr.observe(el); });

    /* barre de progression holo en haut de page */
    var pb = document.createElement('div');
    pb.className = 'u-progress';
    pb.setAttribute('aria-hidden', 'true');
    document.body.appendChild(pb);

    var hero = document.querySelector('.u-hero');
    var hm = hero && hero.querySelector('.u-hero-media');
    var hi = hero && hero.querySelector('.u-hero-in');
    var cue = hero && hero.querySelector('.u-scroll-cue');
    var bgs = [].slice.call(document.querySelectorAll('.u-cta-bg'));

    /* transition entre sections : panneaux qui se déploient / s'éloignent */
    var sheets = [].slice.call(document.querySelectorAll('main .u-section, main .u-cta'));
    sheets.forEach(function (s) {
      if (s.classList.contains('u-sec-pad') || s.classList.contains('u-cta')) s.classList.add('u-sheet');
    });
    function ease(t) { return 1 - Math.pow(1 - t, 3); }

    var ticking = false;

    function frame() {
      ticking = false;
      var y = window.scrollY || 0, vh = window.innerHeight || 1;
      var max = Math.max(1, de.scrollHeight - vh);
      pb.style.transform = 'scaleX(' + Math.min(1, y / max).toFixed(4) + ')';
      de.classList.toggle('u-scrolled', y > 40);
      if (hero && y < vh * 1.4) {
        var h = hero.offsetHeight || vh;
        if (hm) hm.style.translate = '0 ' + Math.min(y * .22, h * .055).toFixed(1) + 'px';
        if (hi) {
          var k = Math.min(1, y / (h * .75));
          hi.style.translate = '0 ' + (-y * .1).toFixed(1) + 'px';
          hi.style.opacity = String((1 - k * .9).toFixed(3));
        }
        if (cue) cue.style.opacity = String(Math.max(0, 1 - y / 140));
      }
      bgs.forEach(function (b) {
        var r = b.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (vh - r.top) / (vh + r.height);
        b.style.translate = '0 ' + ((p - .5) * -60).toFixed(1) + 'px';
      });
      sheets.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var sc = 1, op = 1, o = '50% 0';
        if (r.height > vh * .5 && r.bottom > -40 && r.top < vh + 40) {
          var enter = Math.min(1, Math.max(0, (vh - r.top) / (vh * .55)));
          var leave = Math.min(1, Math.max(0, (vh * .55 - r.bottom) / (vh * .55)));
          if (enter < 1 && r.top > 0) { sc = .93 + .07 * ease(enter); o = '50% 0'; }
          else if (leave > 0) { sc = 1 - .05 * leave; op = 1 - .55 * leave; o = '50% 100%'; }
        }
        if (sc === 1 && op === 1) {
          if (s._fx) { s.style.scale = ''; s.style.opacity = ''; s._fx = 0; }
        } else {
          s._fx = 1;
          s.style.transformOrigin = o;
          s.style.scale = sc.toFixed(4);
          s.style.opacity = op.toFixed(3);
        }
      });
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    frame();
  })();
})();